import React from "react";
import { Button } from "antd";
import { LogoutOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { getImpersonatorInfo, stopImpersonation } from "../../../utils/impersonate";

/**
 * Fixed banner shown app-wide while an admin is impersonating a user. Provides a
 * "Kembali ke Admin" action that restores the admin's original session.
 */
const ImpersonationBanner = () => {
    const info = getImpersonatorInfo();
    if (!info) return null;

    const targetName = info.target_nama || 'user';

    return (
        <div
            style={{
                position: 'sticky',
                top: 0,
                zIndex: 1001,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 12,
                padding: '8px 16px',
                background: '#faad14',
                color: '#1f1f1f',
                fontWeight: 500,
            }}
        >
            <span>
                <UserSwitchOutlined style={{ marginRight: 8 }} />
                Anda sedang login sebagai <strong>{targetName}</strong> (mode impersonate).
            </span>
            <Button
                size="small"
                icon={<LogoutOutlined />}
                onClick={stopImpersonation}
            >
                Kembali ke Admin
            </Button>
        </div>
    );
};

export default ImpersonationBanner;
